<script>
  import {Bar, mixins} from 'vue-chartjs'
  import moment from 'moment'

  const {reactiveProp} = mixins

  export default {
    extends: Bar,
    mixins: [reactiveProp],
    props: ['data', 'chartData', 'fromDeviceTime', 'show'],
    mounted() {
      // this.chartData is created in the mixin.
      // If you want to pass options please create a local options object
      this.renderChart(this.makeChartDataSet(this.fromDeviceTime), this.chartOptions)
    },
    watch: {
      data: function () {
        this.renderChart(this.makeChartDataSet(this.fromDeviceTime), this.chartOptions)
      },
      show: function() {
        this.renderChart(this.makeChartDataSet(this.fromDeviceTime), this.chartOptions)
      }
    },
    methods: {
      makeChartDataSet() {
        let labels = []
        let devices = []
        let updates = []
        let toShow;
        let pointRadius = 0;
        switch (this.show) {
            case "day":
                toShow = (this.data || []).concat().reverse().slice(0, 24).reverse()
                pointRadius = 3;
                break;
            case "week":
                toShow = (this.data || []).concat().reverse().slice(0, 168).reverse()
                pointRadius = 1;
                break;
            case "30days":
                toShow = (this.data || []).concat().reverse().slice(0, 720).reverse()
                break;
            default:
                toShow = (this.data || []).concat().reverse().reverse()
        }
        for (let i = 0; i < (toShow || []).length; i++) {
          labels.push(moment(new Date(toShow[i].Hour)).format("DD/MM HH") + "")
          devices.push(toShow[i].NumDevices)
          updates.push(toShow[i].NumUpdates)
        }

        // let labels = ["first", "second", "third"]
        // let devices = [20, 15, 30]
        return {
          labels: labels,
          datasets: [
            {
              label: 'Total Number of Updates',
              data: updates,
              // type: 'line',
              borderColor: 'rgba(255,20,147, 0)',
              borderWidth: 1,
              backgroundColor: 'rgba(72,61,139,0.8)',
              pointRadius: pointRadius,
              yAxisID: 'A'
            },
            {
              label: 'Number of Reporting Devices',
              data: devices,
              type: 'line',
              borderColor: 'rgba(255,20,147,0.8)',
              borderWidth: 1,
              backgroundColor: 'rgba(255,20,147,0)',
              pointRadius: pointRadius,
              yAxisID: 'B'
            },
          ],
        }
      }
    },
    data: function () {
      return {
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scaleOverride: true,
          scaleStartValue: 0,
          elements: {
            // line: {
            //   tension: this.show === "day" || this.show === "week" ? 0 : 1,
            // }
          },
          scales: {
            xAxes: [{
              gridLines: {
                display:false
              },
              ticks: {
                autoSkip: true,
                maxRotation: 90,
                minRotation: 90
              }
            }],
            yAxes: [{
              id: 'A',
              type: 'linear',
              position: 'right',
              ticks: {
                display: false,
                padding: 100,
                min: 0,
                suggestedMax: 2000,
              },
              gridLines: {
                display: false
              }
            }, {
              id: 'B',
              type: 'linear',
              position: 'left',
              ticks: {
                display: false,
                padding: 100,
                min: 0,
                suggestedMax: 60,
              },
              gridLines: {
                display: false
              }
            }]
          },
          layout: {
            padding: {left: 0, right: 0, top: 0, bottom: 0}
          }
        }
      }
    }
  }

</script>

<style scoped>

</style>
